import {Color} from "@/lib/styles";
import ActionButton from "@/lib/components/ActionButton";
import Page from "@/lib/components/Page";
import {useCallback, useEffect, useState} from "react";
import Header from "@/lib/components/Header";
import Nav from "@/lib/components/Nav";
import Message from "@/lib/components/Message";
import {useSession} from "@/lib/auth/auth";
import {AccountEditRequest} from "@/lib/types";
import {fetchBackendNoContent} from "@/lib/backend";
import {TextInput} from "react-native";
import globstyles from "@/lib/globstyles";
import {useLocalSearchParams, useRouter} from "expo-router";
import ErrorMessage from "@/lib/components/ErrorMessage";
import {useAccount} from "@/lib/components/AccountProvider";

export default function VerifyEmailPage() {
    const {id} = useLocalSearchParams();
    const {session} = useSession();
    const router = useRouter();
    const {refreshAccount} = useAccount();

    const [code, setCode] = useState<string>(id ? id.toString() : "");
    const [busy, setBusy] = useState(false);
    const [saveError, setSaveError] = useState<Error | null>(null);

    const saveSettings= useCallback(async()=> {
        setBusy(true);
        setSaveError(null);
        const changes: AccountEditRequest = {
            email_verification_code: code,
        };
        fetchBackendNoContent(`/account`, "PATCH", session, changes).then(async () => {
            setCode("");
            await refreshAccount();
            router.navigate(`/u/account/settings`);
        }).catch((error) => {
            setSaveError(error);
        }).finally(() => {
            setBusy(false);
        });
    }, [code, router, session, refreshAccount]);

    useEffect(() => {
        if (!id) {
            return;
        }
        saveSettings().catch(() => {
        });
    }, [id, saveSettings]);

    return (
        <Page scrollable={true}>
            <Header title={"Bekreft e-postadresse"} icon={"settings"} center={true}/>

            {id && <Message text={"Trykk på knappen for å bekrefte din e-postadresse."}/>}
            {!id && <Message text={"Skriv inn verifikasjonskoden fra e-posten vi sendte deg."}/>}
            {!id &&
                <TextInput style={globstyles.formTextInput}
                           placeholder={"Verifikasjonskode"}
                           placeholderTextColor={Color.FadedText}
                           value={code}
                           onChangeText={(value) => {
                               setCode(value);
                               setSaveError(null);
                           }}
                           inputMode={"text"}
                           returnKeyType={"send"}
                           enablesReturnKeyAutomatically={true}
                           focusable={true}
                           keyboardAppearance={"dark"}
                           submitBehavior={"submit"}
                           onSubmitEditing={() => saveSettings()}
                />
            }

            {saveError && <ErrorMessage error={saveError}/>}

            <Nav>
                <ActionButton title={"Bekreft"} icon={"checkmark"} busy={busy} color={Color.Green} onPress={saveSettings}/>
            </Nav>
        </Page>
    );
}